module.exports = __webpack_public_path__ + "img/redMarker.ddc0b0db.svg";